import { VNode, h } from '@stencil/core';

import { formatAmount } from '../../../utils/utils.counteroffer';

export const ModalHeader = (_props, children: VNode[]) => {
  const [heading, subtext] = children;
  return (
    <div slot="header">
      <h1 class="text-lg font-extrabold font-montserrat">{heading}</h1>
      <span class="text-sm">{subtext}</span>
    </div>
  );
};

export const Footer = () => (
  <span class="text-clrs-charcoal">
    Dealer inspection required. If the info you provide about the vehicle differs from the dealer inspection, the Offer amount may be decreased.
  </span>
);

export const YourCounteroffer = ({ amount = 0 }, children: VNode[]) => (
  <div class="flex justify-between max-sm:flex-col gap-y-4 gap-x-8">
    <div>
      <span class="text-sm font-bold whitespace-nowrap">Your Counteroffer</span>
      <div class="text-5xl font-bold text-clrs-green mt-1">{formatAmount(amount)}</div>
    </div>

    {children}
  </div>
);

export const BulletList = (_props, children: VNode[]) => {
  const [leadingText, ...list] = children;
  return (
    <div class="text-sm">
      {leadingText}
      <ul class="pl-6 marker:text-bullet">{list}</ul>
    </div>
  );
};
